import { render, staticRenderFns } from "./punishmentDetail.vue?vue&type=template&id=57b4d339&scoped=true"
import script from "./punishmentDetail.vue?vue&type=script&lang=js"
export * from "./punishmentDetail.vue?vue&type=script&lang=js"
import style0 from "./punishmentDetail.vue?vue&type=style&index=0&id=57b4d339&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b4d339",
  null
  
)

export default component.exports